import React, { useState } from 'react';
import FirstUpper from '../../../../../../Components/FirstUpper';
import useTranslation from '../../../../../../Hooks/useTranslation';
import { NCZIContactPerson } from '../../../../Interfaces/ncziPatientInformations';
import NCZIEditContactPersonModal from '../EditContactPersonModal/NCZIEditContactPersonModal';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import NCZICommandResult from '../../../NCZICommandResult/NCZICommandResult';
import { StornoPatientSummaryContactInformation } from '../../../../Commands/StornoPatientSummaryContactInformation';
import useNCZICommandProcess from '../../../../Hooks/useNCZICommandProcess';

//@ts-ignore
import styles from './ElectronicHealthCardContactInfoContactPerson.module.scss';
import NZCIListItem from '../../../Base/NZCIListItem';
import { FormattedDateTime } from '../../../../../../Components/FormattedDate';
import RemoveButton from '../../../../../../Components/Button/RemoveButton';

interface Props {
	contact: NCZIContactPerson;
	patientIdentifier: string;
	handleReloadData?: () => void;
}

const ElectronicHealthCardContactInfoContactPerson: React.FC<Props> = ({
	contact,
	patientIdentifier,
	handleReloadData,
}) => {
	const [editModalOpened, setEditModalOpened] = useState<boolean>(false);
	const { processingCommandId, processCommand, isProcessing } =
		useNCZICommandProcess({
			onFinish: () => handleReloadData?.(),
		});

	const handleCloseModal = (reloadData: boolean) => {
		setEditModalOpened(false);
		if (reloadData) {
			handleReloadData?.();
		}
	};

	const handleStornoRecord = async () => {
		const stornoCommand = StornoPatientSummaryContactInformation({
			patientCode: patientIdentifier,
			recordIds: [contact.rcId],
		});

		await processCommand(stornoCommand);
	};

	if (isProcessing && processingCommandId) {
		return <NCZICommandResult commandId={processingCommandId} />;
	}

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.header}>
					<div className={styles.title}>{contact.fullName}</div>
					<div className={styles.controls}>
						<LinkButton
							title={'base.shared.edit'}
							theme={Theme.BLUE}
							firstUpper
							onClick={() => setEditModalOpened(true)}
						/>
						<RemoveButton
							title={'nczi.action.delete'}
							onClick={() => handleStornoRecord()}
						/>
					</div>
				</div>
				<div className={styles.content}>
					{contact.createdAt && (
						<NZCIListItem
							title='nczi.createdAt'
							value={<FormattedDateTime datetime={contact.createdAt} />}
							align
						/>
					)}
					{contact.email && (
						<NZCIListItem
							title='base.shared.email'
							value={contact.email}
							align
						/>
					)}
					{contact.phone && (
						<NZCIListItem
							title='base.shared.phone'
							value={contact.phone}
							align
						/>
					)}
					{contact.note && (
						<NZCIListItem
							title='base.internalNote'
							value={contact.note}
							align
						/>
					)}
					{contact.type?.displayName && (
						<NZCIListItem
							title='base.shared.type'
							value={contact.type?.displayName}
							align
						/>
					)}
				</div>
			</div>
			<NCZIEditContactPersonModal
				contactPerson={contact}
				patientIdentifier={patientIdentifier}
				opened={editModalOpened}
				onClose={handleCloseModal}
			/>
		</>
	);
};

export default ElectronicHealthCardContactInfoContactPerson;
